import { Route, Routes, useNavigate } from "react-router-dom";
import MainLayout from "./Components/layout/MainLayout";
import Login from "./login";
import { useEffect, useState } from "react";
import BranchLayout from "./Components/layout/BranchLayout";
import "react-toastify/dist/ReactToastify.css";
import { Bounce, ToastContainer } from "react-toastify";
import { useTheme } from "next-themes";

function App() {
  const navigate = useNavigate();
  const { theme, systemTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  const currentTheme = theme === "system" ? systemTheme : theme;

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    // Check if the token exists in local storage
    const token = localStorage.getItem("token");
    const currentPath = window.location.pathname;

    // Only redirect if we're not already on the login page
    if (!token && currentPath !== "/login") {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <div className={``}>
      <Routes>
        <Route path="/*" element={<MainLayout />} />
        <Route path="/branches/:branchId/*" element={<BranchLayout />} />
        <Route path="/login" element={<Login />} />
      </Routes>
      {mounted && (
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme={currentTheme === "dark" ? "dark" : "light"}
          transition={Bounce}
          style={{
            fontSize: "14px",
            fontWeight: "500",
          }}
          toastStyle={{
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            padding: "12px 16px",
          }}
          progressStyle={{
            height: "3px",
          }}
        />
      )}
    </div>
  );
}

export default App;
